import React, { useState, useEffect, useCallback, useMemo } from 'react';

import { TableSearchListdDef } from '~/componentslocal/'
import { Input } from '~/components/Form'
import * as S from './styles'

import { format, parseISO } from 'date-fns';
import { isEmpty } from 'lodash'



export default function DetalheCertificado(props) {

    const { data } = props
    const { visible } = props

    const [domo, setDomo] = useState([])
    const [tanque, setTanque] = useState([])

    useEffect(() => {
        if (!isEmpty(data)) {
            handleGetDomos(data)
            handleGetTanques(data)
        }
    }, [props])



    const handleGetDomos = useCallback((data) => {
        let arrayAltura = Object.entries(data).filter((item) => item[0].includes('avta_domo_cm_'))
        let arrayVolume = Object.entries(data).filter((item) => item[0].includes('avta_domo_vol_'))
        let arrayDomo = []
        for (let index in arrayAltura) {
            let itemVolume = arrayVolume[index]
            let itemAltura = arrayAltura[index]
            arrayDomo.push({ avta_domo_cm: itemAltura[1], avta_domo_vol: itemVolume[1] })
        }
        setDomo(arrayDomo)

    }, [])

    const domoHeader = useMemo(() => [
        {
            id: 'avta_domo_cm',
            label: 'Altura'
        },
        {
            id: 'avta_domo_vol',
            label: 'Volume'
        },

    ], [])

    const handleGetTanques = useCallback((data) => {
        let arrayAltura = Object.entries(data).filter((item) => item[0].includes('avta_tnq_cm_'))
        let arrayVolume = Object.entries(data).filter((item) => item[0].includes('avta_tnq_vol_'))
        let arrayTanque = []
        for (let index in arrayAltura) {
            let itemVolume = arrayVolume[index]
            let itemAltura = arrayAltura[index]
            arrayTanque.push({ avta_tnq_cm: itemAltura[1], avta_tnq_vol: itemVolume[1] })
        }
        setTanque(arrayTanque)

    }, [])

    const tanqueHeader = useMemo(() => [
        {
            id: 'avta_tnq_cm',
            label: 'Altura'
        },
        {
            id: 'avta_tnq_vol',
            label: 'Volume'
        },

    ], [])


    return (
        <>
            { data && <S.Header initialData={{
                ...data,
                avta_dta_afericao: format(parseISO(data.avta_dta_afericao), 'dd/MM/yyyy'),
                avta_dta_vencimento: format(parseISO(data.avta_dta_vencimento), 'dd/MM/yyyy')
            }}>
                <Input name="avta_cod_avta" label="Número do VT" disabled />
                <Input name="empe_desc" label="Empresa" disabled />
                <Input name="avta_num_certificado" label="N° Certificado" disabled />
                <Input name="avta_dta_afericao" label="Data Aferição" disabled />
                <Input name="avta_dta_vencimento" label="Data Vencimento" disabled />

            </S.Header>}

            {visible && (
                <S.Wrapper>
                    <S.WrapperTables>
                        <TableSearchListdDef
                            title="Medidas do Domo"
                            cells={domoHeader}
                            data={domo}
                            size="xs"
                            paginate={5}
                            showCount
                        />
                    </S.WrapperTables>

                    <S.WrapperTables>
                        <TableSearchListdDef
                            title="Medidas do Tanque"
                            cells={tanqueHeader}
                            data={tanque}
                            size="xs"
                            paginate={5}
                            showCount
                        />
                    </S.WrapperTables>

                </S.Wrapper >
            )}

        </>




    );
}
